var map = {
	"./VIT_logo.png": 25,
	"./airbnbLogo.png": 99,
	"./codeInLogo.webp": 100,
	"./codechef.png": 30,
	"./contactMail.webp": 101,
	"./contactMailDark.svg": 102,
	"./developerActivity.svg": 33,
	"./facebookLogo.png": 103,
	"./googleAssistant.svg": 104,
	"./googleAssistantLogo.webp": 105,
	"./hackerRank.png": 23,
	"./harvardLogo.png": 106,
	"./ieee_cs.png": 27,
	"./jsFramework.svg": 107,
	"./manOnTable.svg": 32,
	"./nextuLogo.webp": 29,
	"./programmer.svg": 108,
	"./pwa.webp": 109,
	"./pwaLogo.webp": 110,
	"./quoraLogo.png": 111,
	"./saayaHealthLogo.webp": 28,
	"./samsung_logo.png": 26,
	"./skill.svg": 34,
	"./stanfordLogo.png": 112,
	"./talksCardBack.svg": 113,
	"./talksCardBackAlt.svg": 114
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98;